import { Box } from './kit'
import { box, P } from './projection'

/* ==========================================================================
   The parallel gripper on the carriage (local x 0 = carriage x, which is the
   cap's centre at mid-depth z 80; it rides `grip-dy`). An aluminium body
   with two long fingers that close on the cap's side walls (`grip`). The
   left finger sits behind the cap, the right one in front of it, so they
   are drawn either side of the cap (assemblyScene.jsx).
   ========================================================================== */

const G = -14.4
const BODY = box({ x0: -72 + G, x1: 72 + G, z0: 56, z1: 104, h0: 160, h1: 194 })
const finger = (c) => box({ x0: c - 7 + G, x1: c + 7 + G, z0: 70, z1: 90, h0: 74, h1: 164 })
const FINGERS = { l: finger(-77), r: finger(77) }
/* Polymer grip pads on the inside of each finger tip (front face strip). */
const pad = (x) => `M${x} 563h4v28h-4Z`
const PADS = { l: pad(-75.8), r: pad(68.2) }
const BODY_SCREWS = [-56, 40]
  .map((x) => P(x + G, 177, 56))
  .map(([x, y]) => `M${(x + 3).toFixed(1)} ${y.toFixed(1)}a3 3 0 1 0 -6 0a3 3 0 1 0 6 0`)
  .join('')

function Chrome({ x, y0, y1, w }) {
  return (
    <>
      <rect className="f-cB" x={x - w / 2} y={y0} width={w} height={y1 - y0} />
      <rect className="f-cA" x={x - w / 2} y={y0} width={w * 0.22} height={y1 - y0} />
      <rect className="f-cC" x={x + w * 0.15} y={y0} width={w * 0.35} height={y1 - y0} />
    </>
  )
}

/** Guide rods and piston rod of the carriage's Z cylinder (drawn behind it). */
export function GripRods() {
  return (
    <g className="pp-grip-xy">
      <Chrome x={-28} y0={296} y1={466} w={12} />
      <Chrome x={28} y0={296} y1={466} w={12} />
      <Chrome x={0} y0={296} y1={466} w={10} />
    </g>
  )
}

function Finger({ side }) {
  return (
    <g className={`pp-finger-${side}`}>
      <Box geo={FINGERS[side]} />
      <path className="f-poly" d={PADS[side]} />
    </g>
  )
}

/** The finger behind the cap. */
export function FingerBehind() {
  return (
    <g className="pp-grip-xy">
      <Finger side="l" />
    </g>
  )
}

/** The finger in front of the cap, and the body over both. */
export function GripperFront() {
  return (
    <g className="pp-grip-xy">
      <Finger side="r" />
      <Box geo={BODY} />
      <path className="l-aS pp-hair" d={`M${(-70 + G + 10.1).toFixed(1)} 506H${(70 + G + 10.1).toFixed(1)}`} />
      <path className="f-gR pp-hair" d={BODY_SCREWS} />
    </g>
  )
}
